import { postRequest, postRequestWithToken, postFileRequestWithToken } from '.';
import Toast from '../utils/toast';

// Fetch available timeslots for a date.
// IMPORTANT: use the token so backend can identify the user and apply
// repeat-booking discount logic (within 7 days) correctly.
const Timeslot = async payload => {
  try {
    const timeslotPath = `/timeslot`;
    return await postRequestWithToken(timeslotPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const BookAppointment = async payload => {
  try {
    const appointmentPath = `/book_appointment`;
    return await postFileRequestWithToken(appointmentPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

// Lightweight phone-based discount check for guest checkout
const CheckGuestDiscount = async (phone) => {
  try {
    const path = `/razorpay/check_guest_discount`;
    return await postRequest(path, { phone });
  } catch (error) {
    // Silently fail — discount check is optional
    return null;
  }
};

// Razorpay robust flow: backend creates order via Orders API and stores an intent
const CreateRazorpayAppointmentOrder = async payload => {
  try {
    const path = `/razorpay/create_appointment_order`;
    return await postFileRequestWithToken(path, payload);
  } catch (error) {
    const errMsg = error?.response?.data?.msg || error?.response?.data?.message || 'Something went wrong';
    Toast('error', errMsg);
    // Return the error response so the caller gets the actual backend message
    if (error?.response?.data) {
      return error.response;
    }
  }
};

// Razorpay robust flow: verify signature + finalize booking
const VerifyRazorpayAppointmentPayment = async payload => {
  try {
    const path = `/razorpay/verify_appointment_payment`;
    return await postRequest(path, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const Appointments = async payload => {
  try {
    const appointmentPath = `/appointments`;
    return await postRequestWithToken(appointmentPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const TransactionHistory = async payload => {
  try {
    const transactionhistoryPath = `/transaction_history`;
    return await postRequestWithToken(transactionhistoryPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const AppointmentDetail = async (payload) => {
  try {
    const appointmentDetailPath = `/appointment_detail`;
    return await postRequestWithToken(appointmentDetailPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const CancelAppointment = async (payload) => {
  try {
    const cancelPath = `/cancel_appointment`;
    return await postRequestWithToken(cancelPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const GetPage = async (payload) => {
  try {
    const getpagepath = `/get_page`;
    return await postRequestWithToken(getpagepath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const DownloadInvoice = async (payload) => {
  try {
    const downloadInvoicePath = `/download_invoice`;
    return await postRequestWithToken(downloadInvoicePath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const GetInvoiceUrl = async (payload) => {
  try {
    const getInvoiceUrlPath = `/get_invoice_url`;
    return await postRequestWithToken(getInvoiceUrlPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

// Update appointment (for rescheduling)
const UpdateAppointment = async (payload) => {
  try {
    const updatePath = `/update_appointment`;
    return await postRequestWithToken(updatePath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};


export const appointmentService = {
  Timeslot,
  BookAppointment,
  CreateRazorpayAppointmentOrder,
  VerifyRazorpayAppointmentPayment,
  Appointments,
  TransactionHistory,
  AppointmentDetail,
  CancelAppointment,
  GetPage,
  DownloadInvoice,
  GetInvoiceUrl,
  CheckGuestDiscount,
  UpdateAppointment
};
